/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPYESORNO } from './IAPYESORNO';
import {
    IAPYESORNOFromJSON,
    IAPYESORNOFromJSONTyped,
    IAPYESORNOToJSON,
} from './IAPYESORNO';

/**
 * 
 * @export
 * @interface BaseIndividualDetailsViewModel
 */
export interface BaseIndividualDetailsViewModel {
    /**
     * 
     * @type {string}
     * @memberof BaseIndividualDetailsViewModel
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseIndividualDetailsViewModel
     */
    initials: string;
    /**
     * 
     * @type {string}
     * @memberof BaseIndividualDetailsViewModel
     */
    surname: string;
    /**
     * 
     * @type {Date}
     * @memberof BaseIndividualDetailsViewModel
     */
    dateOfBirth?: Date;
    /**
     * 
     * @type {IAPYESORNO}
     * @memberof BaseIndividualDetailsViewModel
     */
    hasSouthAfricanIDNumber?: IAPYESORNO;
    /**
     * 
     * @type {string}
     * @memberof BaseIndividualDetailsViewModel
     */
    identityNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseIndividualDetailsViewModel
     */
    passportNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseIndividualDetailsViewModel
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseIndividualDetailsViewModel
     */
    popiaStatus?: string;
    /**
     * 
     * @type {Date}
     * @memberof BaseIndividualDetailsViewModel
     */
    detailsLastUpdated?: Date;
}

/**
 * Check if a given object implements the BaseIndividualDetailsViewModel interface.
 */
export function instanceOfBaseIndividualDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "initials" in value;
    isInstance = isInstance && "surname" in value;

    return isInstance;
}

export function BaseIndividualDetailsViewModelFromJSON(json: any): BaseIndividualDetailsViewModel {
    return BaseIndividualDetailsViewModelFromJSONTyped(json, false);
}

export function BaseIndividualDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseIndividualDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstName': !exists(json, 'FirstName') ? undefined : json['FirstName'],
        'initials': json['Initials'],
        'surname': json['Surname'],
        'dateOfBirth': !exists(json, 'DateOfBirth') ? undefined : (new Date(json['DateOfBirth'])),
        'hasSouthAfricanIDNumber': !exists(json, 'HasSouthAfricanIDNumber') ? undefined : IAPYESORNOFromJSON(json['HasSouthAfricanIDNumber']),
        'identityNumber': !exists(json, 'IdentityNumber') ? undefined : json['IdentityNumber'],
        'passportNumber': !exists(json, 'PassportNumber') ? undefined : json['PassportNumber'],
        'displayName': !exists(json, 'DisplayName') ? undefined : json['DisplayName'],
        'popiaStatus': !exists(json, 'PopiaStatus') ? undefined : json['PopiaStatus'],
        'detailsLastUpdated': !exists(json, 'DetailsLastUpdated') ? undefined : (new Date(json['DetailsLastUpdated'])),
    };
}

export function BaseIndividualDetailsViewModelToJSON(value?: BaseIndividualDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'FirstName': value.firstName,
        'Initials': value.initials,
        'Surname': value.surname,
        'DateOfBirth': value.dateOfBirth === undefined ? undefined : (value.dateOfBirth.toISOString()),
        'HasSouthAfricanIDNumber': IAPYESORNOToJSON(value.hasSouthAfricanIDNumber),
        'IdentityNumber': value.identityNumber,
        'PassportNumber': value.passportNumber,
        'DisplayName': value.displayName,
        'PopiaStatus': value.popiaStatus,
        'DetailsLastUpdated': value.detailsLastUpdated === undefined ? undefined : (value.detailsLastUpdated.toISOString()),
    };
}

